// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","3546":"3c1a9c6d","7348":"3c1a9c6d"}[chunkId] + ".chunk.css";
};